import { useEffect, useState } from 'react';

interface ScreenSize {
  width: number;
  height: number;
}

// Read viewport synchronously so the very first render sees the real
// dimensions, not `0×0`. The previous initial-state-of-null + populate-
// in-effect pattern caused the parent layout to mount once with
// `screenSize.width = 0` (treating the viewport as mobile, hiding the
// sider entirely) and then re-render a frame later when the effect
// fired, "snapping" the sider into place. The user observed that
// snap as a brief left-sidebar resize. Initializing synchronously
// produces a stable layout from the first paint.
function readViewport(): ScreenSize {
  if (typeof window === 'undefined') {
    return { width: 0, height: 0 };
  }
  return { width: window.innerWidth, height: window.innerHeight };
}

export const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>(readViewport);

  useEffect(() => {
    const handleResize = () => setScreenSize(readViewport());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};
